import React from 'react';
import { BriefPage } from './BriefPage';
import { BriefHeader } from './BriefHeader';
import { SystemSwimlane } from './SystemSwimlane';
import { useDocPaging } from '../../contexts/DocPagingContext';
import { usePricing } from '../../contexts/PricingContext';
import { briefTrackRecord } from '../../data/partnershipBrief';
import { launchHeadline, launchLeaderSpotlight, launchOutcomes, launchProblems, launchSystem, launchSystemWithRecruiter } from '../../data/launchProposal';
const label = 'text-[12px] font-bold uppercase tracking-[0.14em] text-[#4a5560]';

/** Page 1 of the D2D Launch proposal: the value story for a new channel. */
export function LaunchPageOne() {
  const paging = useDocPaging();
  const {
    hasRecruiter
  } = usePricing();
  const stages = hasRecruiter ? launchSystemWithRecruiter : launchSystem;
  return <BriefPage data-id="element-788" data-mp="1ai1mcpolbtbn">
      <BriefHeader label="D2D Launch proposal" data-id="element-789" data-mp="1ahjl1en2mowv" />

      <h1 className="brief-display mt-6 text-[44px] font-extrabold leading-[1.04] tracking-[-0.02em] max-w-[720px]" data-id="element-790" data-mp="1famja02smmje">
        {launchHeadline.title}
      </h1>
      <p className="mt-3 text-[17px] leading-[1.5] text-[#2c3640] max-w-[760px]" data-id="element-791" data-mp="8gq04jxc5oga">
        {launchHeadline.lead}
      </p>

      <h2 className={`mt-6 ${label}`} data-id="element-792" data-mp="hbxldl903kgh">Why most D2D launches stall</h2>
      <div className="mt-3 grid grid-cols-3 gap-5" data-id="element-793" data-mp="hd8p5l2g4s7l">
        {launchProblems.map(problem => <div key={problem.title} className="border-t border-[#d5dade] pt-3" data-id="element-794" data-mp="ciup35cu9wwl">
            <div className="text-[16px] font-bold" data-id="element-795" data-mp="r7qusvrfaxu1">{problem.title}</div>
            <p className="mt-0.5 text-[14.5px] leading-[1.5] text-[#2c3640]" data-id="element-796" data-mp="m9fm4ocv6tde">
              {problem.body}
            </p>
          </div>)}
      </div>

      {/* The build is sequential, so it reads as one track left to right. */}
      <h2 className={`mt-6 ${label}`} data-id="element-797" data-mp="w6k6cin5gerk">How we build your channel</h2>
      <div className="mt-3" data-id="element-798" data-mp="322ekicxuphk5">
        <SystemSwimlane stages={stages} data-id="element-799" data-mp="323poacraqpb9" />
      </div>

      <section className="mt-6 rounded-xl bg-[#121a20] px-7 py-6" data-id="element-800" data-mp="2y132ashb3ylz">
        <div className="text-[12px] font-bold uppercase tracking-[0.14em] text-[#6fd6b0]" data-id="element-801" data-mp="10znf2ln39h09">
          {launchLeaderSpotlight.eyebrow}
        </div>
        <div className="mt-2 grid grid-cols-[1.25fr_1fr] gap-8" data-id="element-802" data-mp="15z9vf3y7rdda">
          <div data-id="element-803" data-mp="1ax1uchx9zzqz">
            <h2 className="brief-display text-[27px] font-extrabold leading-[1.15] text-white" data-id="element-804" data-mp="1awjpwy0gmf7z">
              {launchLeaderSpotlight.title}
            </h2>
            <p className="mt-2.5 text-[14.5px] leading-[1.55] text-[#d7dde2]" data-id="element-805" data-mp="1jy9hc3ucde5r">
              {launchLeaderSpotlight.body}
            </p>
          </div>
          <dl className="flex flex-col justify-center gap-3" data-id="element-806" data-mp="1ow1izpksgen5">
            {launchLeaderSpotlight.stats.map(stat => <div key={stat.label} className="border-l-2 border-[#6fd6b0] pl-3" data-id="element-807" data-mp="1touls7wp5cwl">
                <dt className="brief-display text-[21px] font-extrabold text-white leading-tight" data-id="element-808" data-mp="1ymmgf9oq7d4h">
                  {stat.value}
                </dt>
                <dd className="text-[13.5px] text-[#aab4bc]" data-id="element-809" data-mp="27nkkfrz5zkn2">{stat.label}</dd>
              </div>)}
          </dl>
        </div>
      </section>

      <h2 className={`mt-6 ${label}`} data-id="element-810" data-mp="3s7fvt3ji4hjg">What you walk away with</h2>
      <ul className="mt-3 grid grid-cols-2 gap-x-7 gap-y-3.5" data-id="element-811" data-mp="3o41g6dzh636j">
        {launchOutcomes.map(outcome => <li key={outcome.title} className="flex gap-3" data-id="element-812" data-mp="3j69eis9132p5">
            <span className="mt-0.5 font-bold text-[#14684d] text-[16px]" aria-hidden="true" data-id="element-813" data-mp="3e63lb7n4184y">
              ✓
            </span>
            <div data-id="element-814" data-mp="fnogkf3rbx9v">
              <div className="text-[16px] font-bold leading-snug" data-id="element-815" data-mp="fqaowgyh2gt5">
                {outcome.title}
              </div>
              <p className="mt-0.5 text-[14px] leading-[1.5] text-[#2c3640]" data-id="element-816" data-mp="5yerl847mupz">
                {outcome.body}
              </p>
            </div>
          </li>)}
      </ul>

      <div className="mt-6 border-t-2 border-[#141a1f] pt-3 pb-2.5 grid grid-cols-4 gap-5 border-b border-b-[#d5dade]" data-id="element-817" data-mp="xqymgwf83t4">
        {briefTrackRecord.map(stat => <div key={stat.label} data-id="element-818" data-mp="tmo8bvmkgsa9">
            <div className="brief-display text-[36px] font-extrabold leading-none text-[#14684d]" data-id="element-819" data-mp="tmfwm726jt0n">
              {stat.value}
            </div>
            <div className="mt-1.5 text-[14px] text-[#2c3640]" data-id="element-820" data-mp="i8vz5tbvtc6k">
              {stat.label}
            </div>
          </div>)}
      </div>

      <footer className="mt-auto pt-6 flex items-center justify-between text-[13px]" data-id="element-821" data-mp="4aegwb4qwrw1">
        <span className="text-[#2c3640]" data-id="element-822" data-mp="97ek8ea7ngjg">D2D HIRE · {paging.label(1)}</span>
        <span className="font-bold" data-id="element-823" data-mp="wy1v98ffama8">
          Pricing, guarantees and timeline on page {paging.page(2)} →
        </span>
      </footer>
    </BriefPage>;
}